import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { Box } from '@mui/material';
import { HeatingCircuit } from 'z3k-config';
import { WaterSensorIndicator } from './components/indicators/water';
import { ControlDevicesIndicator } from './components/indicators/control';
import { CircuitSetPointIndicator } from './components/indicators/set-point';
import './status-line.sass';
export const StatusLine = memo(function StatusLine(props) {
    const { is_fail, only_control_devices, ...rest } = props;
    return (_jsxs(Box, { display: "flex", alignItems: "center", columnGap: 1, justifyContent: "center", children: [!only_control_devices && (_jsx(WaterSensorIndicator, { ...rest, is_fail: is_fail, "data-tooltip": "water-status-temp" })), _jsx(ControlDevicesIndicator, { ...rest, "data-tooltip": "control-devices-status-temp" }), !only_control_devices && !HeatingCircuit.isDHW(rest.heating_circuit) && (_jsx(CircuitSetPointIndicator, { ...props }))] }));
});
